export default __webpack_public_path__ + "static/media/bg-5.1e42ff77.jpg";